import React, { ReactNode } from 'react'
import CardDetails from '../../components/cards/CardsDetails';
type IdCardProps = {
  name: string;
  validity: string;
  idNumber: string;
  dob: string;
  gender: string;
  communityName: string;
  communityLogo: string;
  qrCode: string | ReactNode;
  cardColor?: string | null;
  textColor?: string;
  borderColor?: string;
  idType?: string;
}


const IdCard: React.FC<IdCardProps> = ({ name, validity, idNumber, dob, gender, communityName, cardColor, idType, borderColor = "border-[#1E1E1E]", qrCode, communityLogo, textColor = "text-[#1E1E1E]" }) => {
  return (


    <div
      className={` bg-[${cardColor}] h-[168px] !w-full p-6 justify-center flex flex-col items-center gap-1 rounded-lg`}
      style={{
        ...((cardColor?.length ?? 0) <= 0 ? { background: `linear-gradient(180deg, rgba(77, 68, 85, 1) 17.5%, rgba(56, 70, 106, 1) 99.8%)` } : {}),
        boxShadow: `-1px -2px 1px rgba(255, 255, 255, 0.2),
        1px -2px 1px rgba(255, 255, 255, 0.15),
        1px 2px 2px rgba(255, 255, 255, 0.1)`,
        transform: 'perspective(1000px) rotateX(2deg)',
        willChange: 'transform',
      }}
    >

      <div className='flex justify-center items-center mr-auto'>
        <img className='rounded-full object-cover h-[22px] w-[22px]'
          src={communityLogo}
          width={22}
          height={22}
          alt="alt"
        />
        <p className={`${(cardColor?.length ?? 0) === 0 ? 'text-[#D9D9D9]' : textColor} text-[12px] text-left [font-family:'Avenir-Light',Helvetica] px-2 font-bold `}>
          {communityName}
        </p>
      </div>

      <hr className={`border w-full mt-2 ${(cardColor?.length ?? 0) === 0 ? 'border-[#595160]' : borderColor}`} />
      <p className={`font-family:'Avenir-Light',Helvetica ${(cardColor?.length ?? 0) === 0 ? 'text-[#D9D9D9]' : textColor} mr-auto text-left font-medium text-[12px]`}>
        {name}
      </p>
      <hr className={`border w-full ${(cardColor?.length ?? 0) === 0 ? 'border-[#595160]' : borderColor}`} />
      <div className="w-full flex mt-1 justify-between items-center">

        <div className="flex w-full items-center gap-2 justify-between">

          <CardDetails
            textColor={(cardColor?.length ?? 0) === 0 ? '#D9D9D9' : textColor}
            validity={validity}
            idNumber={idNumber}
            dob={dob || ''}
            gender={gender}
            idType={idType}
          />
        </div>
        {typeof qrCode === 'string' ? (
          <img
            className='rounded-md'
            src={qrCode}
            width={38}
            height={38}
            alt=""
          />
        ) : (
          <div className=' w-[54px] !h-[54px] rounded-[2px] shrink-0 bg-white flex justify-center items-center'>
            {qrCode}
          </div>
        )}
      </div>
    </div>
  )
}

export default IdCard